import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: { display: 'flex', alignItems: 'center' },
  buttonsContainer: {
    marginLeft: theme.spacing(0.5),
    whiteSpace: 'nowrap'
  }
}));
